<template>
  <div>
    <div class="invisible-card" style="margin-bottom: 12px">
      <h1>Liste de tous les quiz</h1>
      <h4>Cliquez sur une UE pour afficher les quiz pour tous les sujets d'une matière.</h4>
    </div>
    <div
        class="invisible-card ue-space"
        v-for="course in revisionSheet"
        :key="course.group"
    >
      <div class="closableDivOpen">
        <h3 class="main-separator">{{ course.group }}</h3>
        <div class="square-card spec-card closableDiv" :id="'open-close-div' + course.group">
          <div
              v-for="(ue, index) in course.ue"
              :key="index">
            <h3 @click="open_close_div('-open-close-div' + ue.name)" class="secondary-ue">
              {{ ue.name }}
            </h3>
            <div class="closableDiv" :id="'-open-close-div' + ue.name" style="max-height: 0">
              <div
                  v-for="subject in ue.subjects"
                  :key="subject.name">
                <router-link :to="`/${ue.link}/quiz/${subject._id}`">
                  <span class="third-subject">{{ subject.name }}</span>
                </router-link>
                <div class="space-break-line"></div>
              </div>
              <div>
                <router-link :to="ue.link">
                  <span class="third-subject">🡆 Page de l'UE</span>
                </router-link>
                <div class="space-break-line"></div>
                <router-link :to="ue.link + '/test'">
                  <span class="third-subject">🡆 Lancer un test sur l'UE entière</span>
                </router-link>
                <div class="space-break-line"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios"

  export default {
    name: "training",
    data() {
      return {
        revisionSheet: []
      }
    },
    methods: {
      open_close_div(id) {
        let target = document.getElementById(id)

        if (target.parentElement.classList.contains('closableDivOpen')) {
          target.style.maxHeight = '0'
          target.parentElement.classList.remove('closableDivOpen')
        }
        else {
          target.style.maxHeight = target.scrollHeight + 'px'
          target.parentElement.classList.add('closableDivOpen')

          if (id[0] === '-') {
            let parent = target.parentElement.parentElement
            parent.style.maxHeight = (parent.scrollHeight + target.scrollHeight) + 'px'
          }
        }
      }
    },
    mounted() {
      window.scrollTo(0, 0)
      let  toReduces = document.getElementsByClassName('closableDiv')
      for (let tR of toReduces)
        if (!tR.style.maxHeight) tR.style.maxHeight = tR.scrollHeight + 'px'
    },
    created() {
      axios.get(`/training`).then((res) => {
        this.revisionSheet = res.data
      }).catch(error => {
        console.log(error)
      })
    }
  }
</script>

<style scoped>

  .ue-space {
    margin-top: -10px;
    margin-bottom: 10px;
    border-radius: 6px;
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .ue-space > div {
    margin: 17px 0 10px;
  }
  .ue-space > div > div {
    margin-top: 7px;
  }

  .closableDiv {
    margin: unset;
    overflow: hidden;
    transition: .15s ease 100ms;
  }
  .spec-card {
    padding: 18px 22px;
  }
  .main-separator {
    margin: 12px 0;
    display: flex;
    align-items: baseline
  }

  .secondary-ue {
    margin: 12px 0 9px 40px;
    font-weight: 500;
    cursor: pointer;
    position: relative;
  }
  .secondary-ue::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -30px;
    transform: translate(0, -50%) rotate(90deg);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 8px solid var(--color-text-1);
    transition: .2s ease-out .2s;
  }
  .ue-link {
    padding-left: 8px;
    font-size: 16px;
    color: black;
  }

  .closableDiv > div {
    opacity: 0;
    transition: .5s ease-in-out .25s;
  }
  .closableDivOpen > .closableDiv > div {
    opacity: 1;
  }
  .closableDivOpen > .secondary-ue::before {
    transform: translate(0, -50%) rotate(180deg);
    transition: .2s ease-out;
  }
  .space-break-line {
    display: block;
  }
  .third-subject {
    display: inline-block;
    margin: 3px 0 7px 60px;
    cursor: pointer;
    position: relative;
  }
  .third-subject::after {
    content: "";
    position: absolute;
    top: 19px;
    left: 0;
    height: 1px;
    background-color: var(--color-text-3);
    width: 0;
    transition: .2s;
  }

  @media (hover: hover) {
    .third-subject:hover::after {
      width: 100%;
    }
    .ue-link:hover {
      text-decoration: underline;
    }
  }
</style>